<template>
  <div class="checkbox">
    <input type="checkbox" id="checkbox" ref="checkbox" :checked="value" @input="emitInput">
    <label for="checkbox">
      Oświadczam, iż zapoznałem się z postanowieniami
      <router-link
        to="/terms"
        target="_blank"
      >regulaminu i polityką przetwarzania danych</router-link>.
    </label>
  </div>
</template>

<script>
export default {
  name: 'TermsCheckbox',
  props: {
    value: {
      type: Boolean,
    },
  },
  methods: {
    emitInput() {
      this.$emit('input', this.$refs.checkbox.checked);
    },
  },
};
</script>

<style scoped>
/* Na podstawie:
 * https://medium.com/claritydesignsystem/pure-css-accessible-checkboxes-and-radios-buttons-54063e759bb3 */

.checkbox {
  font-size: 14px;
  box-sizing: border-box;
  margin: 5px 0 10px;
}

.checkbox input[type='checkbox'] {
  opacity: 0;
}

.checkbox label {
  position: relative;
  display: inline-block;
  padding-left: 22px;

  width: 320px;
  text-align: justify;
}

.checkbox label::before,
.checkbox label::after {
  position: absolute;
  content: '';
  display: inline-block;
}

.checkbox label::before {
  height: 16px;
  width: 16px;
  border: 1px solid;
  left: 0px;
  top: 3px;
}

.checkbox.invalid label::before {
  border-color: red;
}

.checkbox label::after {
  height: 5px;
  width: 9px;
  border-left: 2px solid;
  border-bottom: 2px solid;
  transform: rotate(-45deg);
  left: 4px;
  top: 7px;
}

.checkbox label a:hover {
  color: var(--color-hover);
}

.checkbox input[type='checkbox'] + label::after {
  content: none;
}

.checkbox input[type='checkbox']:checked + label::after {
  content: '';
}

.checkbox input[type='checkbox']:focus + label::before {
  outline: var(--color-hover) auto 1px;
}
</style>
